export default __webpack_public_path__ + "media/images/theme/bg_light-27470cdb19fb63340a29a491c564daaf.png";